import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, message, Spin } from 'antd';
import request from '../../utils/api';

const { TextArea } = Input;

export default function System() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => { loadConfig(); }, []);

  async function loadConfig() {
    setLoading(true);
    try {
      const res = await request.get('/system/admin/config');
      form.setFieldsValue(res.data);
    } catch (e) {} finally { setLoading(false); }
  }

  async function handleSave(values) {
    setSaving(true);
    try {
      await request.put('/system/admin/config', values);
      message.success('配置已保存');
    } catch (e) {
      message.error('保存失败');
    } finally { setSaving(false); }
  }

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>;

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>系统设置</h2>
      <Card style={{ maxWidth: 700 }}>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name="camp_name" label="营地名称">
            <Input placeholder="城市绿地营地" />
          </Form.Item>
          <Form.Item name="camp_address" label="营地地址">
            <Input placeholder="上海市浦东新区XX路XX号" />
          </Form.Item>
          <Form.Item name="camp_phone" label="联系电话">
            <Input placeholder="400-XXX-XXXX" />
          </Form.Item>
          <Form.Item name="service_qrcode" label="客服微信二维码URL">
            <Input placeholder="https://example.com/qrcode.jpg" />
          </Form.Item>
          <Form.Item name="camp_intro" label="营地介绍（HTML）">
            <TextArea rows={6} placeholder="<p>营地介绍内容...</p>" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={saving}>保存设置</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
